import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { DirectiveModule } from '../helper/directive/directive.module';
import { HeaderComponent } from '../shared/header/header.component';
import { SharedModule } from '../shared/shared.module';
import { SideMenuComponent } from '../shared/side-menu/side-menu.component';
import { WidgetsModule } from '../widgets/widgets.module';

@NgModule({
  declarations: [ LayoutComponent, SideMenuComponent, HeaderComponent ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    WidgetsModule,
    MatSidenavModule,
    MatTabsModule,
    MatToolbarModule,
    MatMenuModule,
    TranslateModule,
    MatProgressSpinnerModule,
    DirectiveModule,
    SharedModule,
  ],
  exports: [ LayoutComponent, RouterModule ]
})
export class LayoutModule {}
